import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Modal,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// actions
import {
  resetClientSystemVariables,
  resetError,
  getClientSystemVariables,
  deleteClientSystemVariable,
} from "../../store/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { isArray } from "../../Libs/CustomMethods/customMethods";

const ClientSystemVariables = ({ t }) => {
  const dispatch = useDispatch();
  const qtdDefault = 7;

  const {
    dataClientSystemVariable,
    dataClientSystemVariableDelete,
    loadingClientSystemVariable,
    loadingClientSystemVariableDelete,
    errorClientSystemVariable,
    successClientSystemVariable,
  } = useSelector((state) => state.ClientSystemVariables);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [clientSystemVariableId, setClientSystemVariableId] = useState("");
  const [clientSystemVariableName, setClientSystemVariableName] = useState("");

  const [nameFilter, setNameFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successClientSystemVariable &&
      dispatch(resetClientSystemVariables()) &&
      handleFilter(),
  };

  const handleFilter = (name) => {
    setNameFilter(name);
    setPage(1);
    dispatch(getClientSystemVariables(null, 1, qtdDefault, name));
  };

  const handleDelete = () => {
    dispatch(deleteClientSystemVariable(clientSystemVariableId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setClientSystemVariableIdName = (clientSystemVariable) => {
    setClientSystemVariableId(clientSystemVariable.id);
    setClientSystemVariableName(clientSystemVariable.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getClientSystemVariables(null, value, qtdDefault, nameFilter));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataClientSystemVariable && dataClientSystemVariable.paging) {
      if (page < dataClientSystemVariable.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  useEffect(() => {
    if (dataClientSystemVariableDelete?.message) {
      showToast("success", t(dataClientSystemVariableDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successClientSystemVariable]);

  useEffect(() => {
    if (isArray(errorClientSystemVariable)) {
      errorClientSystemVariable.forEach((error) =>
        showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorClientSystemVariable) {
        showToast("error", t(errorClientSystemVariable));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorClientSystemVariable]);

  useEffect(() => {
    if (dataClientSystemVariable !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataClientSystemVariable]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/systemvariables"
            title={t("Dashboard")}
            breadcrumbItem={t("System Variables")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="6"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="12"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div
                          className="text-sm-right mb-3"
                          id="new-clientSystemVariable"
                        >
                          <Link to={`/systemvariable`}>
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add System Variable")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>{t("Name")}</th>
                            <th className="w-100">{t("Value")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingClientSystemVariable ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataClientSystemVariable?.clientSystemVariables
                              ?.length > 0 ? (
                            dataClientSystemVariable?.clientSystemVariables?.map(
                              (systemvariable, key) => (
                                <tr key={key}>
                                  <td>
                                    <div className="py-3">
                                      {systemvariable.name}
                                    </div>
                                  </td>
                                  <td style={{ maxWidth: 50 }}>
                                    <PerfectScrollbar className="py-3">
                                      {systemvariable.value}
                                    </PerfectScrollbar>
                                  </td>
                                  <td>
                                    <div className="d-flex py-3">
                                      <Link
                                        to={`/systemvariable/${systemvariable.id}`}
                                        className="text-primary text-center"
                                        id="edit"
                                      >
                                        <i
                                          className="mdi mdi-pencil font-size-18 px-2"
                                          id="edittooltip"
                                        ></i>
                                        <UncontrolledTooltip
                                          placement="auto"
                                          target="edittooltip"
                                        >
                                          {t("Edit")}
                                        </UncontrolledTooltip>
                                      </Link>

                                      <div style={{ cursor: "pointer" }}>
                                        <i
                                          className="mdi mdi-window-close text-danger font-size-18 px-2"
                                          id="deletetooltip"
                                          onClick={() => {
                                            toggleModal();
                                            setClientSystemVariableIdName(
                                              systemvariable
                                            );
                                          }}
                                        ></i>
                                        <UncontrolledTooltip
                                          placement="auto"
                                          target="deletetooltip"
                                        >
                                          {t("Delete")}
                                        </UncontrolledTooltip>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal
                        isOpen={modal || loadingClientSystemVariableDelete}
                      >
                        <div className="modal-body font-size-18 text-center">
                          {t("Do you want to delete the system variable")}
                          <strong> {clientSystemVariableName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingClientSystemVariableDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (clientSystemVariableId) handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>

                  {dataClientSystemVariable &&
                  dataClientSystemVariable.paging &&
                  dataClientSystemVariable.paging.length > 1 ? (
                    <Pagination className="pagination pagination-rounded justify-content-end my-2">
                      <PaginationItem onClick={handlePreviousPage}>
                        <PaginationLink previous />
                      </PaginationItem>

                      {dataClientSystemVariable &&
                        dataClientSystemVariable.paging &&
                        dataClientSystemVariable.paging.map((value, index) => {
                          return (
                            <PaginationItem
                              key={index}
                              onClick={() => {
                                handlePage(value);
                              }}
                              active={page === value ? true : false}
                            >
                              <PaginationLink
                                key={index}
                                style={{ display: "inline" }}
                              >
                                {value}
                              </PaginationLink>
                            </PaginationItem>
                          );
                        })}
                      <PaginationItem onClick={handleNextPage}>
                        <PaginationLink next />
                      </PaginationItem>
                    </Pagination>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(ClientSystemVariables);
